<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <b-form @submit="onSubmit" oninput='password.setCustomValidity(password2.value != password.value ? "Lösenorden matchar inte." : "")'>
          <b-form-group id="emailGroup" label="E-postadress:" label-for="email">
            <b-form-input
              id="email"
              type="email"
              v-model="form.email"
              required
              placeholder="E-postadress"
            />
          </b-form-group>
          <b-form-group id="userNameGroup" label="Användarnamn:" label-for="userName">
            <b-form-input
              id="userName"
              type="text"
              v-model="form.userName"
              required
              placeholder="Användarnamn"
            />
          </b-form-group>

          <b-form-group id="firstNameGroup" label="Förnamn:" label-for="firstName">
            <b-form-input
              id="firstName"
              type="text"
              v-model="form.firstName"
              required
              placeholder="Förnamn"
            />
          </b-form-group>
          <b-form-group id="lastNameGroup" label="Efternamn:" label-for="lastName">
            <b-form-input
              id="lastName"
              type="text"
              v-model="form.lastName"
              required
              placeholder="Efternamn"
            />
          </b-form-group>
          <b-form-group id="phoneGroup" label="Telefon:" label-for="phone">
            <b-form-input
              id="phone"
              type="text"
              v-model="form.phone"
              required
              placeholder=""
            />
          </b-form-group>
          <b-form-group id="roleGroup" label="Roll:" label-for="roles">
            <b-form-select id="roles" :options="roles" required v-model="form.role" />
          </b-form-group>
           <b-form-checkbox id="checkbox-C" v-model="form.permissionC" name="permissionC" value="Ja" unchecked-value="Nej">Behörighet C</b-form-checkbox>
          <b-form-checkbox id="checkbox-CE" v-model="form.permissionCE" name="permissionCE" value="Ja" unchecked-value="Nej">Behörighet CE</b-form-checkbox>
          <b-form-checkbox id="checkbox-ADR" v-model="form.permissionADR" name="permissionADR" value="Ja" unchecked-value="Nej">Behörighet ADR</b-form-checkbox>
          <b-form-checkbox id="checkbox-ADRTank" v-model="form.permissionADRTank" name="permissionADRTank" value="Ja" unchecked-value="Nej">Behörighet ADR Tank</b-form-checkbox>
          <b-form-checkbox id="checkbox-Truck" v-model="form.permissionTruck" name="permissionTruck" value="Ja" unchecked-value="Nej">Truckförarbevis</b-form-checkbox>
          <b-form-checkbox id="checkbox-Bakgavel" v-model="form.permissionBakgavel" name="permissionBakgavel" value="Ja" unchecked-value="Nej">Bakgavelliftbevis</b-form-checkbox>
          <b-form-checkbox id="checkbox-Kran" v-model="form.permissionKran" name="permissionKran" value="Ja" unchecked-value="Nej">Kranförarbevis</b-form-checkbox>
          <b-form-checkbox id="permissionLoadAcidFromKemira" v-model="form.permissionLoadAcidFromKemira" name="permissionLoadAcidFromKemira" value="Ja" unchecked-value="Nej">Behörighet lasta från Kemira</b-form-checkbox>
          <b-form-checkbox id="permissionLoadAcidFromInovyn" v-model="form.permissionLoadAcidFromInovyn" name="permissionLoadAcidFromInovyn" value="Ja" unchecked-value="Nej">Behörighet lasta från Inovyn</b-form-checkbox>
          <b-form-checkbox id="permissionLoadProductFromVet" v-model="form.permissionLoadProductFromVet" name="permissionLoadProductFromVet" value="Ja" unchecked-value="Nej">Behörighet lasta från Vetlanda</b-form-checkbox>
          <b-form-checkbox id="permissionLoadProductFromSol" v-model="form.permissionLoadProdFrSolE90" name="permissionLoadProdFrSolE90" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Eko 90 </b-form-checkbox>
          <b-form-checkbox id="permissionLoadProdFrSolE70" v-model="form.permissionLoadProdFrSolE70" name="permissionLoadProdFrSolE70" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Eko 70 </b-form-checkbox>
          <b-form-checkbox id="permissionLoadProdFrSolFE" v-model="form.permissionLoadProdFrSolFE" name="permissionLoadProdFrSolFE" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Järnklorid </b-form-checkbox>
          <b-form-checkbox id="permissionLoadProdFrSolPlusP" v-model="form.permissionLoadProdFrSolPlusP" name="permissionLoadProdFrSolPlusP" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Pluspac </b-form-checkbox>
          <b-form-checkbox id="permissionLoadProdFrSolLut" v-model="form.permissionLoadProdFrSolLut" name="permissionLoadProdFrSolLut" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg Lut </b-form-checkbox>
          <b-form-checkbox id="permissionUnloadProductInVet" v-model="form.permissionUnloadProductInVet" name="permissionUnloadProductInVet" value="Ja" unchecked-value="Nej">Behörighet lossa i Vetlanda</b-form-checkbox>
          <b-form-checkbox id="permissionUnloadProductInSol" v-model="form.permissionUnloadProductInSol" name="permissionUnloadProductInSol" value="Ja" unchecked-value="Nej">Behörighet lossa i Sölvesborg</b-form-checkbox>
          <b-form-checkbox id="checkbox-subContractor" v-model="form.subContractor" name="subContractor" value="Ja" unchecked-value="Nej">Underleverantör</b-form-checkbox>
          <b-form-checkbox id="permissionLoadAcidFromKemira" v-model="form.permissionLoadAcidFromKemira" name="permissionLoadAcidFromKemira" value="Ja" unchecked-value="Nej">Behörighet lasta från Kemira</b-form-checkbox>
          <b-form-checkbox id="permissionLoadAcidFromInovyn" v-model="form.permissionLoadAcidFromInovyn" name="permissionLoadAcidFromInovyn" value="Ja" unchecked-value="Nej">Behörighet lasta från Inovyn</b-form-checkbox>
          <b-form-checkbox id="permissionLoadProductFromVet" v-model="form.permissionLoadProductFromVet" name="permissionLoadProductFromVet" value="Ja" unchecked-value="Nej">Behörighet lasta från Vetlanda</b-form-checkbox>
          <b-form-checkbox id="permissionLoadProductFromSol" v-model="form.permissionLoadProductFromSol" name="permissionLoadProductFromSol" value="Ja" unchecked-value="Nej">Behörighet lasta från Sölvesborg</b-form-checkbox>
          <b-form-checkbox id="permissionUnloadProductInVet" v-model="form.permissionUnloadProductInVet" name="permissionUnloadProductInVet" value="Ja" unchecked-value="Nej">Behörighet lossa i Vetlanda</b-form-checkbox>
          <b-form-checkbox id="permissionUnloadProductInSol" v-model="form.permissionUnloadProductInSol" name="permissionUnloadProductInSol" value="Ja" unchecked-value="Nej">Behörighet lossa i Sölvesborg</b-form-checkbox>
           <b-form-group id="customersGroup" label="Kund:" label-for="customers">
            <b-form-select id="customers" :options="customers" v-model="form.customer" />
          </b-form-group>
           <b-form-group id="passwordGroup" label="Lösenord:" label-for="password">
            <b-form-input
              id="password"
              type="password"
              v-model="form.password"
              required
              placeholder="Lösenord"
              name="password"
            />
          </b-form-group>
           <b-form-group id="passwordGroup2" label="Bekräfta lösenord:" label-for="password2">
            <b-form-input
              id="password2"
              type="password"
              required
              placeholder="Skriv lösenordet igen"
              name="password2"
            />
          </b-form-group>
          <Button :type="submit" label="Spara" class="p-button-success" icon="pi pi-check" ></Button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button'
export default {
  name: 'UserCreate',
  components: {
    Button
  },
  data () {
    return {
      msg: 'Skapa användare',
      user: '',
      show: true,
      form: {
        email: '',
        userName: '',
        firstName: '',
        lastName: '',
        phone: '',
        role: null,
        customer: null,
        password: '',
        permissionC: 'Nej',
        permissionCE: 'Nej',
        permissionADR: 'Nej',
        permissionADRTank: 'Nej',
        permissionTruck: 'Nej',
        permissionBakgavel: 'Nej',
        permissionKran: 'Nej',
        permissionLoadAcidFromKemira: 'Nej',
        permissionLoadAcidFromInovyn: 'Nej',
        permissionLoadProductFromVet: 'Nej',
        permissionLoadProdFrSolE90: 'Nej',
        permissionLoadProdFrSolE70: 'Nej',
        permissionLoadProdFrSolFE: 'Nej',
        permissionLoadProdFrSolPlusP: 'Nej',
        permissionLoadProdFrSolLut: 'Nej',
        permissionUnloadProductInVet: 'Nej',
        permissionUnloadProductInSol: 'Nej',
        subContractor: ''
      },
      roles: [{ text: 'Välj..', value: null }, 'User', 'Driver', 'Admin', 'Extern', 'Revisor'],
      customers: [{ text: 'Välj..', value: null }]
    }
  },
  mounted () {
    this.getCustomers()
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      var url = '/api/users'
      this.$http
        .post(url, { user: this.form })
        .then(response => {
          this.$router.push('/userlist')
        })
        .catch(error => console.log(error))
    },
    getCustomers () {
      this.$http
        .get('/api/customers')
        .then(response => {
          var customers = response.data.customers
          for (var i = 0; i < customers.length; i++) {
            this.customers.push({value: customers[i].id, text: customers[i].data.name})
          }
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users/UserCreate.vue